import { LightningElement, api, wire } from "lwc";
import { MENU_ADAPTER_DEFAULT_VALUE, MenuAdapter } from "common/menuAdapter";
import { createTrack } from "common/track";
import { attrToBool, hash } from "common/helpers";

class appLauncher extends LightningElement {
  @api get open() {
    return this._open;
  }

  set open(value) {
    attrToBool(value) ? this.menu.open() : this.menu.close();
  }

  _open = false;
  @api apps = [];
  @api label = "";
  menu = MENU_ADAPTER_DEFAULT_VALUE;

  @wire(MenuAdapter, {
    items: "$apps",
    template: "$template",
  })
  onMenuChange(menu) {
    this.menu = menu; // Wait until menu is visually open to recalculate layout

    requestAnimationFrame(() => this.resizeMenu());

    if (this.menu.state.open && this.menu.state.open !== this.open) {
      this.track("opened", undefined);
    }

    this._open = this.menu.state.open;
  }

  track = createTrack(this);

  get menuOptions() {
    return this.apps.map((app) => ({
      ...app,
      key: `app_${hash(app.label)}`,
      onClick: () => {
        this.track("link_clicked", {
          label: app.label,
        });
      },
    }));
  }

  resizeMenu() {
    let $menu = this.template.querySelector(".menu");
    if (!$menu) return;
    $menu.style.transform = "";
    $menu.style.width = "";
    let rect = $menu.getBoundingClientRect();
    let shouldResize = this.open && rect.x < 0;
    $menu.style.width = shouldResize
      ? "calc(100vw - var(--tds-spacing-2) * 2)"
      : "";
    let rectResized = $menu.getBoundingClientRect();
    $menu.style.transform = shouldResize
      ? `translate(calc(${Math.abs(rectResized.x)}px + var(--tds-spacing-2)),0)`
      : "";
  }
}

export default appLauncher;
